// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"48":"metamask","167":"PageNotFound","375":"dati","966":"login"}[chunkId] || chunkId) + "." + {"48":"0b5d8788","167":"4d083e04","184":"0b4ed40b","375":"ffa97314","966":"a4e92afe"}[chunkId] + ".js";
};